import React from 'react';
import { Link } from 'react-router-dom';

const AccessDeniedPage: React.FC = () => {
  return (
    <div className="page-shell">
      <div className="container detail-container">
        <div className="card auth-panel">
          <p className="eyebrow">Permissions</p>
          <h1 className="page-heading">Access denied</h1>
          <p className="page-copy">
            Your account does not have permission to view that page.
          </p>
          <div className="hero-actions">
            <Link to="/" className="btn btn-primary">Go to home</Link>
            <Link to="/archive" className="btn btn-secondary">Go to archive</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;